'use strict';

const values = [
    {
        value: 'Bill Image',
        display: 'Bill Image',
        level: 1,
        category: 'Directives'
    },
    {
        value: 'Provider List',
        display: 'Provider List',
        level: 1,
        category: 'Directives'
    },
    {
        value: 'Living Will',
        display: 'Living Will',
        level: 1,
        category: 'Directives'
    },
    {
        value: 'DNR',
        display: 'DNR',
        level: 1,
        category: 'Directives'
    },
    {
        value: 'Advance Directive',
        display: 'Advance Directive',
        level: 1,
        category: 'Directives'
    },
    {
        value: 'POST/POLST',
        display: 'POST/POLST',
        level: 1,
        category: 'Directives'
    },
    {
        value: 'Power of Attorney',
        display: 'Power of Attorney',
        level: 1,
        category: 'Directives'
    },
    {
        value: 'Consent',
        display: 'Consent',
        level: 1,
        category: 'Enrollment'
    },
    {
        value: 'Authorization',
        display: 'Authorization',
        level: 1,
        category: 'Enrollment'
    },
    {
        value: 'Insurance Card',
        display: 'Insurance Card',
        level: 2,
        category: 'Insurance Information'
    },
    {
        value: 'Policy Information',
        display: 'Policy Information',
        level: 2,
        category: 'Insurance Information'
    },
    {
        value: 'Explanation of Benefits',
        display: 'Explanation of Benefits',
        level: 2,
        category: 'Insurance Information'
    },
    {
        value: 'Verification of Benefits',
        display: 'Verification of Benefits',
        level: 2,
        category: 'Insurance Information'
    },
    {
        value: 'Medical Records Request',
        display: 'Medical Records Request',
        level: 2,
        category: 'Insurance Information'
    },
    {
        value: 'Signed medical records release',
        display: 'Signed medical records release',
        level: 2,
        category: 'Insurance Information'
    },
    {
        value: 'Medical records from Provider’s office',
        display: 'Medical records from Provider’s office',
        level: 2,
        category: 'Insurance Information'
    },
    {
        value: 'Medical records from hospital',
        display: 'Medical records from hospital',
        level: 2,
        category: 'Insurance Information'
    },
    {
        value: 'UM case information',
        display: 'UM case information',
        level: 2,
        category: 'Insurance Information'
    },
    {
        value: 'Single Case Agreement',
        display: 'Single Case Agreement',
        level: 2,
        category: 'Insurance Information'
    },
    {
        value: 'Pre-Procedure Instructions',
        display: 'Pre-Procedure Instructions',
        level: 3,
        category: 'Pre-Procedure'
    },
    {
        value: 'Photo of Medication',
        display: 'Photo of Medication',
        level: 4,
        category: 'Photos'
    },
    {
        value: 'Photo of Reaction',
        display: 'Photo of Reaction',
        level: 4,
        category: 'Photos'
    },
    {
        value: 'Photo of Patient',
        display: 'Photo of Patient',
        level: 4,
        category: 'Photos'
    },
    {
        value: 'Photo of Member',
        display: 'Photo of Member',
        level: 4,
        category: 'Photos'
    },
    {
        value: 'Education',
        display: 'Education',
        level: 5,
        category: 'Education'
    },
    {
        value: 'Prescription',
        display: 'Prescription',
        level: 4,
        category: 'Prescription'
    },
    {
        value: 'Other',
        display: 'Other - Clinical',
        level: 6,
        category: 'Other'
    },
    {
        value: 'Other - Non-clinical',
        display: 'Other - Non-clinical',
        level: 6,
        category: 'Other'
    }
];

const makeItem = (val) => {
    return {
        value: { display: val.value, code: val.value },
        label: val.display,
        level: val.level,
        category: val.category,
        code: val.value
    };
};

module.exports = values.map(makeItem);
